import { queryClient } from "./query-client";

export const CUSTOMER_UUID_QUERY_KEY = "customer-uuid";

export const WF_BANKING_BASE_URL_BACKEND = "/api/banking/:customerUuid";
const WF_NOTIFICATIONS_BASE_URL_BACKEND = "/api/notifications/:customerUuid";

export const getBaseUrlBankingBackend = (): string => {
  const customerUuid = queryClient.getQueryData<string>([CUSTOMER_UUID_QUERY_KEY]);
  if (!customerUuid) {
    throw new Error("Customer UUID not found");
  }
  const result = WF_BANKING_BASE_URL_BACKEND.replace(":customerUuid", customerUuid);
  return result;
};

export const getBaseUrlNotificationsBackend = (): string => {
  const customerUuid = queryClient.getQueryData<string>([CUSTOMER_UUID_QUERY_KEY]);
  if (!customerUuid) {
    throw new Error("Customer UUID not found");
  }
  const result = WF_NOTIFICATIONS_BASE_URL_BACKEND.replace(":customerUuid", customerUuid);
  return result;
};
